<!--
 * @Author: huadan
 * @Date: 2021-04-09 10:05:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-19 11:41:19
 * @Description: 修改密码
-->
<style lang="less" scoped>
.modify-password {
  display: flex;
  flex-direction: column;

  .title {
    font-size: @font_size_6;
    font-weight: bold;
    margin: 30px 0;
  }
  .show-password-icon {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    cursor: pointer;
  }
}
</style>

<template>
  <NeoPageLayout class="modify-password">
    <a-row class="title" type="flex" justify="center">
      <a-col :span="8">{{ $t('modifyPassword.title') }}</a-col>
    </a-row>
    <!--  修改密码 -->
    <a-form-model ref="form" :labelCol="labelCol" :wrapperCol="wrapperCol" :model="form" :rules="rules">
      <!--  原密码 -->
      <a-form-model-item prop="password" :label="$t('modifyPassword.old_password')">
        <a-input
          v-model="form.password"
          type="password"
          autocomplete="off"
          :placeholder="$t('modifyPassword.confirm_old_password')"
        />
      </a-form-model-item>
      <!--  新密码 -->
      <a-form-model-item prop="newPassword" :label="$t('modifyPassword.new_password')">
        <a-input
          v-model="form.newPassword"
          :placeholder="$t('placeholder.NewPassword')"
          autocomplete="off"
          :type="passwordVisible ? 'text' : 'password'"
        >
          <template #suffix>
            <span v-if="form.newPassword.length == 0" @click="generatePassword">
              <NeoIcon name="suiji" :size="18" style="cursor: pointer" />
            </span>
            <span v-else @click="(e) => handleVisibleChange(e)" class="show-password-icon">
              <NeoIcon :name="passwordVisible ? 'eyeline' : 'eyecloseline'" class="icon active" :size="18" />
            </span>
          </template>
        </a-input>
      </a-form-model-item>
      <!--  确认密码 -->
      <a-form-model-item prop="confirmPassword" :label="$t('modifyPassword.confirm_password')">
        <a-input
          v-model="form.confirmPassword"
          autocomplete="off"
          :placeholder="$t('modifyPassword.confirm_new_password2')"
          :type="passwordConfirmVisible ? 'text' : 'password'"
        >
          <template #suffix>
            <span @click="(e) => handleShowConfirmPassword(e)" class="show-password-icon">
              <NeoIcon :name="passwordConfirmVisible ? 'eyeline' : 'eyecloseline'" class="icon active" :size="18" />
            </span>
          </template>
        </a-input>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 8, offset: 9 }">
        <a-button type="primary" @click="onSubmit">{{ $t('modifyPassword.confirm_modify') }}</a-button>
      </a-form-model-item>
    </a-form-model>
  </NeoPageLayout>
</template>
<script>
import { Icon } from 'ant-design-vue'
import md5 from 'js-md5'
import { generateRandomPassword, passwordRegex, clearLoginInfo } from '@/utils/utils'
import Cookies from 'js-cookie'
const { validate } = window.$g

export default {
  name: 'modifyPassword',
  data() {
    const checkConfirm = (rule_, value, callback) => {
      const password = this.form.newPassword
      if (value && password && value !== password) {
        callback(this.$t('modifyPassword.check_confirm'))
      } else {
        callback()
      }
    }

    return {
      labelCol: { span: 9 },
      wrapperCol: { span: 6 },
      form: {
        password: '',
        newPassword: '',
        confirmPassword: '',
      },
      //规则
      rules: {
        password: [validate.required, validate.min_string_6],
        newPassword: [validate.required, validate.min_string_6, validate.passwordStrength],
        confirmPassword: [validate.required, validate.min_string_6, { validator: checkConfirm }],
      },
      passwordVisible: false,
      passwordConfirmVisible: false,
    }
  },
  methods: {
    //提交
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            await this.$http('password', {
              password: md5(this.form.password),
              newPassword: md5(this.form.newPassword),
            })
            this.loading = false
            // 重置表单
            this.$refs.form.resetFields()
            this.$success({
              title: this.$t('modifyPassword.modify_success'),
              icon: (h) => h(Icon, { props: { type: 'check-circle', theme: 'filled' } }),
              content: this.$t('modifyPassword.pw_modify_success'),
              okText: this.$t('confirm'),
              onOk: () => {
                if (this.$store.state.app.userInfo.superTenant === 1) {
                  this.$router.push({ name: 'employee' })
                } else {
                  this.$router.push({ name: 'home' })
                }
              },
            })
            Cookies.set('isPasswordValid', passwordRegex.test(this.form.newPassword))
            this.handleLogout()
          } catch (err) {
            this.loading = false
            this.$httpNotify(err)
          }
        }
      })
    },
    // 生成随机密码
    generatePassword() {
      const password = generateRandomPassword()
      this.form.newPassword = password
      this.form.confirmPassword = password
      // passwordVisible.value = false; // 确保生成密码后为密文显示
    },
    handleVisibleChange(e) {
      e.preventDefault()
      this.passwordVisible = !this.passwordVisible
    },
    handleShowConfirmPassword(e) {
      e.preventDefault()
      this.passwordConfirmVisible = !this.passwordConfirmVisible
    },
    // 退出登录
    async handleLogout() {
      this.$g.clearLocalStorage()
      await this.$http('logout')
      clearLoginInfo()
      this.$g.returnLogin()
    },
  },
}
</script>
